import { ArrowBack, ArrowForward, Close } from "@mui/icons-material"
import { Dialog, DialogContent, IconButton } from "@mui/material"
import React from "react"

function ModalMediaView({
    open,
    handleClose,
    handlePrev,
    handleNext,
    currentIndex,
    form,
}) {
    return (
        <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
            <DialogContent sx={{ position: "relative", p: 0 }}>
                <IconButton
                    onClick={handleClose}
                    sx={{
                        position: "absolute",
                        top: 8,
                        right: 8,
                        color: "white",
                        background: "rgba(0,0,0,0.5)",
                    }}
                >
                    <Close />
                </IconButton>

                <IconButton
                    onClick={handlePrev}
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: 8,
                        transform: "translateY(-50%)",
                        color: "white",
                        background: "rgba(0,0,0,0.5)",
                    }}
                >
                    <ArrowBack />
                </IconButton>

                <IconButton
                    onClick={handleNext}
                    sx={{
                        position: "absolute",
                        top: "50%",
                        right: 8,
                        transform: "translateY(-50%)",
                        color: "white",
                        background: "rgba(0,0,0,0.5)",
                    }}
                >
                    <ArrowForward />
                </IconButton>

                {form.product && (
                    <>
                        {form.product.medias[currentIndex]?.mediaType ===
                        "image" ? (
                            <img
                                src={
                                    form.product.medias[currentIndex]
                                        .fileFullURL
                                }
                                alt={
                                    form.product.medias[currentIndex].title ||
                                    "Imagem do produto"
                                }
                                style={{
                                    width: "100%",
                                    height: "auto",
                                    objectFit: "contain",
                                    borderRadius: 8,
                                }}
                            />
                        ) : (
                            <video
                                controls
                                style={{
                                    width: "100%",
                                    height: "auto",
                                    borderRadius: 8,
                                }}
                            >
                                <source
                                    src={
                                        form.product.medias[currentIndex]
                                            .fileFullURL
                                    }
                                    type={`video/${form.product.medias[currentIndex].extension}`}
                                />
                                Seu navegador não suporta vídeos.
                            </video>
                        )}
                    </>
                )}
            </DialogContent>
        </Dialog>
    )
}

export default ModalMediaView
